import BaseFeature from '../../foundation/base/base';

class GtmEcommImpressions extends BaseFeature {
	constructor(element) {
		super(element);

		this.element = element;

		this.currency = element.dataset.currency;
		this.dataNodes = element.querySelectorAll('[data-impression]');

		this.ecommData = {
			ecommerce: {
				currencyCode: '',
				impressions: []
			}
		};

		this.init();
	}

	init() {
		this.ecommData.ecommerce.currencyCode = this.currency;

		this.dataNodes.forEach((element) => {
			const impression = JSON.parse(element.dataset.impression);
			const ecommDataImpression = {};
			ecommDataImpression.name = impression.name;
			ecommDataImpression.id = impression.id;
			ecommDataImpression.price = impression.price;
			ecommDataImpression.brand = impression.brand;
			ecommDataImpression.category = impression.category;
			ecommDataImpression.variant = impression.variant;
			ecommDataImpression.list = impression.list;
			ecommDataImpression.position = impression.position;

			this.ecommData.ecommerce.impressions.push(ecommDataImpression);
		});

		this.log(this.ecommData);

		this.push();
	}

	push() {
		if (window.dataLayer) {
			window.dataLayer.push(this.ecommData);
		}
	}
}

export default GtmEcommImpressions;
